import React, { useState, useEffect, useRef } from "react";
import styles from "./style.module.scss";

import iphone from "../../../images/home/iphone.png";
import computer from "../../../images/home/computer.png";
import box from "../../../images/home/shirtBox.png";

export default function Process() {
  const [offsetTop, setOffsetTop] = useState(null);
  const [translate, setTranslate] = useState(0);
  const [windowWidth, setWindowWidth] = useState(null);
  const stepRef = useRef();
  const containerRef = useRef();
  const scrollBarHeight = 115;

  function handleResize() {
    const windowHeight = window.innerHeight;
    const stepHeight = stepRef.current.clientHeight;

    const offset = (windowHeight - stepHeight) / 2.0;

    setOffsetTop(offset);
    setWindowWidth(window.innerWidth);
  }

  function handleScroll() {
    const windowHeight = window.innerHeight;
    const { top, height } = containerRef.current.getBoundingClientRect();
    const { height: stepHeight } = stepRef.current.getBoundingClientRect();

    if (top < 0) {
      const scrollHeight = height - windowHeight;
      const pctScrolled = Math.abs(top) / scrollHeight;
      const availableTranslate = stepHeight - scrollBarHeight;
      const offset = pctScrolled * availableTranslate;
      const translateY = Math.min(offset, availableTranslate);
      setTranslate(translateY);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  return (
    <div className={styles.container} ref={containerRef}>
      <div className={styles.steps} style={{ top: offsetTop }} ref={stepRef}>
        <ul>
          <li key="design">
            {windowWidth <= 718 && (
              <img src={iphone} key="iphone" alt="iphone" />
            )}
            <h3>Design</h3>
            <p>
              Experts in fashion, our talented team of designers will create
              something you love for FREE.
            </p>
          </li>
          <li key="order">
            {windowWidth <= 718 && (
              <img src={computer} key="computer" alt="computer" />
            )}
            <h3>Order</h3>
            <p>
              Who said collecting orders had to be hard? We make it easy with
              our online ordering platform.
            </p>
          </li>
          <li key="love">
            {windowWidth <= 718 && <img src={box} key="box" alt="box" />}
            <h3>Love</h3>
            <p>
              We make products that people love and remember, that’s why we’re
              the fastest-growing custom college apparel company!
            </p>
          </li>
        </ul>
        {windowWidth >= 718 && (
          <div
            className={styles.scrollBar}
            style={{
              transform: `translateY(${translate}px)`,
              height: `${scrollBarHeight}px`
            }}
          />
        )}
      </div>
      {windowWidth > 718 && (
        <div className={styles.images}>
          <img src={iphone} key="iphone" alt="iphone" />
          <img src={computer} key="computer" alt="computer" />
          <img src={box} key="box" alt="box" />
        </div>
      )}
    </div>
  );
}
